"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _avatar = require("../styles/avatar");

var _containers = require("../styles/containers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var renderGroupAvatarImg = function renderGroupAvatarImg(_ref) {
  var imgSrc = _ref.imgSrc,
      name = _ref.name,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["imgSrc", "name"]);

  return imgSrc ? /*#__PURE__*/_react["default"].createElement(_avatar.GroupAvatarImage, _extends({
    key: name,
    imgSrc: imgSrc
  }, otherProps)) : /*#__PURE__*/_react["default"].createElement(_avatar.GroupAvatarImage, _extends({
    key: name
  }, otherProps), name && name[0] || "");
};

var _default = function _default(_ref2) {
  var placeholderText = _ref2.placeholderText,
      imgSrc = _ref2.imgSrc,
      _ref2$avatars = _ref2.avatars,
      avatars = _ref2$avatars === void 0 ? [] : _ref2$avatars,
      otherProps = _objectWithoutPropertiesLoose(_ref2, ["placeholderText", "imgSrc", "avatars"]);

  return imgSrc || avatars && avatars.length === 1 && avatars[0].imgSrc ? /*#__PURE__*/_react["default"].createElement(_avatar.Avatar, _extends({
    src: imgSrc || avatars[0].imgSrc
  }, otherProps)) : avatars && avatars.length > 1 ? /*#__PURE__*/_react["default"].createElement(_avatar.AvatarWrapper, otherProps, /*#__PURE__*/_react["default"].createElement(_containers.FlexColumn, {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    overflow: "hidden"
  }, avatars.slice(0, 2).map(function (_ref3) {
    var imgSrc = _ref3.imgSrc,
        name = _ref3.name;
    return renderGroupAvatarImg(_extends({
      imgSrc: imgSrc,
      name: name
    }, otherProps));
  })), avatars.length > 2 && /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    overflow: "hidden"
  }, avatars.slice(2, 4).map(function (_ref4) {
    var imgSrc = _ref4.imgSrc,
        name = _ref4.name;
    return renderGroupAvatarImg(_extends({
      imgSrc: imgSrc,
      name: name
    }, otherProps));
  })))) : /*#__PURE__*/_react["default"].createElement(_avatar.AvatarWrapper, otherProps, placeholderText && placeholderText[0] || "");
};

exports["default"] = _default;
module.exports = exports["default"];